export const formatMoney = (v: number) => Number(v).toLocaleString('ru');